import React from 'react';

import classNames from 'classnames';

import { AlertMessageBody, Props as AlertMessageBodyProps } from './AlertMessageBody';
import { config } from './constants';

type Props = {
  className?: string;
  id?: string;
} & AlertMessageBodyProps;

export const AlertMessage: React.FC<Props> = ({ children, className, level, id, ...rest }) => {
  const { containerClassnames } = config[level];

  return (
    <div
      className={classNames(
        'px-sm outline rounded flex',
        children ? 'py-xxs' : 'py-xs',
        containerClassnames,
        className,
      )}
      id={id}
    >
      <AlertMessageBody level={level} {...rest}>
        {children}
      </AlertMessageBody>
    </div>
  );
};
